export default __webpack_public_path__ + "static/rs-empresarial_02-914dcf8f0e0fb6781128ac879844c852.png";